import { render, staticRenderFns } from "./PayloadLbs.vue?vue&type=template&id=1c5866d8&scoped=true"
import script from "./PayloadLbs.vue?vue&type=script&lang=js"
export * from "./PayloadLbs.vue?vue&type=script&lang=js"
import style0 from "./PayloadLbs.vue?vue&type=style&index=0&id=1c5866d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5866d8",
  null
  
)

export default component.exports